// TODO Додати сюди корисні посилання - Рада, МФ, ДКУ і т.д.,
//  а не корисні - видалити (все, крім гугла) )))

import rada from '../../../assets/img/nav-icons/rada.png';
import mfu from '../../../assets/img/nav-icons/mfu.png';
import dksu from '../../../assets/img/nav-icons/dksu.png';
import dps from '../../../assets/img/nav-icons/dps.png';
import kmu from '../../../assets/img/nav-icons/kmu.png';
import nbu from '../../../assets/img/nav-icons/nbu.png';
import prez from '../../../assets/img/nav-icons/prez.png';
import google from '../../../assets/img/nav-icons/google.png';

// eslint-disable-next-line import/prefer-default-export
export const quickLinks = [
  {
    img: mfu,
    title: 'МФУ',
    link: 'https://www.mof.gov.ua/uk',
  }, {
    img: rada,
    title: 'ВР',
    link: 'https://www.rada.gov.ua/',
  }, {
    img: dksu,
    title: 'ДКСУ',
    link: 'https://www.treasury.gov.ua/',
  }, {
    img: dps,
    title: 'ДПС',
    link: 'https://tax.gov.ua/',
  }, {
    img: nbu,
    title: 'НБУ',
    link: 'https://bank.gov.ua/',
  }, {
    img: kmu,
    title: 'КМУ',
    link: 'https://www.kmu.gov.ua/',
  }, {
    img: prez,
    title: 'Президент',
    link: 'https://www.president.gov.ua/',
  },
  { img: google, title: 'Google', link: 'https://google.com/' },
  // { hr: true },
];
